import "@/styles/globals.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer, Zoom } from "react-toastify";
import { EdgeStoreProvider } from "../lib/edgestore";
import { SessionProvider } from "next-auth/react";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import Head from "next/head";

const queryClient = new QueryClient();

export default function App({ Component, pageProps }) {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/sw.js", { scope: "/prod" })
        .then((registration) => {
          console.log("Service worker registered successfully. Scope:", registration.scope);
        })
        .catch((error) => {
          console.error("Service worker registration failed:", error);
        });
    }
  }, []);

  return (
    <>
      <Head>
        <title>Bebeng's Kitchen</title>
        <meta name="description" content="Where every bite is a delight!" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#ffefcf" />
        <link rel="apple-touch-icon" href="/images/logos/apple_touch_icon_192.png" />
        <link rel="manifest" href="/manifest.json" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <ToastContainer position="top-center" transition={Zoom} autoClose={2000} hideProgressBar={false} newestOnTop={true} pauseOnHover={true} theme={"colored"} />
      <QueryClientProvider client={queryClient}>
        <SessionProvider session={pageProps.session}>
          <EdgeStoreProvider>
            <Component {...pageProps} />
          </EdgeStoreProvider>
        </SessionProvider>
      </QueryClientProvider>
    </>
  );
}
